import React from 'react'
import { observer } from 'mobx-react'
import BoolField from 'bstrap-react-mobx-admin/field/bool'
import BoolInput from 'bstrap-react-mobx-admin/input/bool'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../../input/date'
import EmbededEntityInput from '../../input/embedded_entity'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import RegionsInput from '../../input/regions'
import RightsCopyModal from './rights_copy'
import SelectInput from '../../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import moment from 'moment'

const RightForm = observer(({ store, state, record, updateFormField, errors }) => {
  if (!record.get('control_timestamp')) {
    record.set('control_timestamp', new Date().getTime())
  }
  const { stageOneRestricted, stageTwoRestricted } = store.timeRestriction.checkSubentity(store, state)
  const minDate = store.options.get('timeRestrictions') && store.options.get('timeRestrictions')[0] && store.options.get('timeRestrictions').reverse()[0].date
    ? moment(store.options.get('timeRestrictions').reverse()[0].date).add(1, 'days')
    : moment()
  record.get('minimum_fee_sd') && record.set('minimum_fee_sd', parseFloat(record.get('minimum_fee_sd')).toFixed(2))
  record.get('minimum_fee_hd') && record.set('minimum_fee_hd', parseFloat(record.get('minimum_fee_hd')).toFixed(2))

  return (
    <div className='row'>
      <div className='col-xs-12'>
        <DateInput label={store.__('license starts')} attr={'start_license_period'} minDate={minDate}
          record={record} onChange={updateFormField} errors={errors} disabled={stageOneRestricted} />

        <DateInput label={store.__('license ends')} attr={'end_license_period'} minDate={minDate}
          record={record} onChange={updateFormField} errors={errors} disabled={stageTwoRestricted} />
        {record.has('END_license_period_info') && record.get('END_license_period_info')
          ? <p className='text-success'>{record.get('END_license_period_info')}<br /></p>
          : ''}

        <RegionsInput label={store.__('regions')} attr={'regions'} record={record} onChange={updateFormField}
          optionsrecord={store.options} optionsattr={'Countries'} errors={errors} disabled={stageOneRestricted} />

        <DateInput label={store.__('canceled date')} attr={'canceled_date'} minDate={minDate}
          record={record} onChange={updateFormField} errors={errors} disabled={stageTwoRestricted} />

        <fieldset disabled={stageOneRestricted}>
          <SelectInput label={store.__('status')} attr={'status'} record={record}
            onChange={updateFormField} labelattr='text' valueattr='value'
            optionsrecord={store.options} optionsattr={'ContractItemStatus'} errors={errors} />

          <SelectInput label={store.__('platform')} attr={'platform'} record={record}
            onChange={updateFormField} optionsrecord={store.options}
            optionsattr={'Platforms'} labelattr='text' errors={errors} />

          <SelectInput label={store.__('right type')} attr={'right_type'} record={record}
            onChange={updateFormField} labelattr='text' valueattr='value'
            optionsrecord={store.options} optionsattr={'RightsTypes'} errors={errors} />

          <BoolInput label={store.__('Rights exclusive')} attr={'rights_exclusive_flg'}
            record={record} onChange={updateFormField} />

          <BoolInput label={store.__('Can re-sale')} attr={'can_resale'}
            record={record} onChange={updateFormField} />

          <BoolInput label={store.__('Apply recoupable costs')} attr={'apply_recoupable_costs'}
            record={record} onChange={updateFormField} />

          <SelectInput label={store.__('category')} attr={'category'} record={record}
            onChange={updateFormField} labelattr='text' valueattr='value'
            optionsrecord={store.options} optionsattr={'ContractItemCategory'} errors={errors} />

          <SelectInput label={store.__('pricing tier')} attr={'pricing_tier'} record={record}
            onChange={updateFormField} labelattr='text' valueattr='value'
            optionsrecord={store.options} optionsattr={'ContractPricingTier'} errors={errors} />

          <TextInput type='number' label={store.__('minimum fee SD')} attr={'minimum_fee_sd'}
            record={record} onChange={updateFormField} errors={errors} />

          <TextInput type='number' label={store.__('minimum fee HD')} attr={'minimum_fee_hd'}
            record={record} onChange={updateFormField} errors={errors} />
        </fieldset>
      </div>
    </div>
  )
})

const RightsEdit = ({ store, ...rest }) => {
  const attr = 'rights'
  const attrLength = (store.cv && store.cv.record && store.cv.record.has(attr) && store.cv.record.get(attr) && store.cv.record.get(attr).length > 0)

  return ([
    <EmbededEntityInput {...rest} store={store} key={1}
      attr={attr}
      edit_title={store.__('edit rights')}
      add_title={store.__('add rights')}
      errors={store.cv.errors}
      fields={[
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.end_license_period} valT={row.canceled_date} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.start_license_period} valT={row.canceled_date} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.canceled_date} />),
        (attr, row) => (<OptionsField attr={attr} val={row[attr]}
          options={store.options.get('ContractItemStatus')}
          labelattr='text' valueattr='value' />),
        (attr, row) => (<OptionsField attr={attr} val={row[attr]}
          options={store.options.get('Platforms')} labelattr='text' />),
        (attr, row) => (<OptionsField attr={attr} val={row[attr]}
          options={store.options.get('RightsTypes')}
          labelattr='text' valueattr='value' />),
        (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
        (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} toFixed={2} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} toFixed={2} />)
      ]}
      rowId={(row) => row}
      copyModalToggle={store.cv && store.cv.record && !attrLength && store.toggleRightsCopyModal}
      EditForm={RightForm}
    />,
    <RightsCopyModal store={store} key={2} />
  ])
}
export default RightsEdit
